import {
  Pagination,
  PaginationItem,
  type PaginationProps,
} from "@mui/material";
import { Link } from "@tanstack/react-router";

type Props = PaginationProps & {
  perPage: number;
};

export const NotificationPagination = ({ perPage, ...props }: Props) => (
  <Pagination
    variant="outlined"
    shape="rounded"
    renderItem={(item) => {
      const isNext = item.type === "next";
      const isPrev = item.type === "previous";

      return (
        <PaginationItem
          component={Link}
          to={`/notifications?page=${item.page}&perPage=${perPage}`}
          sx={{
            margin: "0",
            borderTopLeftRadius: isPrev ? "40px" : "0px",
            borderBottomLeftRadius: isPrev ? "40px" : "0px",
            borderTopRightRadius: isNext ? "40px" : "0px",
            borderBottomRightRadius: isNext ? "40px" : "0px",
            color: "grey.700",
            "&.Mui-selected": {
              bgcolor: "grey.50",
            },
          }}
          {...item}
        />
      );
    }}
    {...props}
  />
);
